/**
 * Invoke a callback when the DOM is ready.
 */
export var onDOMReady = function onDOMReady(callback) {
  if (['interactive', 'complete'].includes(document.readyState)) {
    callback();
    return;
  }

  document.addEventListener('DOMContentLoaded', callback);
};